import React, { useEffect, useState } from 'react';
import '../styles/money-fall.css';

const CURRENCY_SYMBOLS = ['$', '€', '£', '¥', '💰', '💎', '✨'];
const numberOfSymbols = 50;

interface MoneySymbol {
  id: number;
  symbol: string;
  duration: number;
  delay: number;
  left: number;
  size: number;
  rotation: number;
}

export default function MoneyFall() {
  const [moneySymbols, setMoneySymbols] = useState<MoneySymbol[]>([]);

  useEffect(() => {
    const generatedSymbols: MoneySymbol[] = Array.from({ length: numberOfSymbols }, (_, i) => ({
      id: i,
      symbol: CURRENCY_SYMBOLS[Math.floor(Math.random() * CURRENCY_SYMBOLS.length)],
      duration: 3 + Math.random() * 4, // 3-7 seconds
      delay: Math.random() * 3, // 0-3 seconds delay
      left: Math.random() * 100, // 0-100% from left
      size: 0.7 + Math.random() * 1.5, // Random size multiplier
      rotation: Math.random() * 360, // Random initial rotation
    }));
    setMoneySymbols(generatedSymbols);
  }, []);

  return (
    <div className="money-fall-container">
      {moneySymbols.map((money) => (
        <div
          key={money.id}
          className="money-symbol"
          style={{
            left: `${money.left}%`,
            fontSize: `${money.size}rem`,
            animation: `fall ${money.duration}s linear ${money.delay}s infinite`,
            transform: `rotate(${money.rotation}deg)`,
          }}
        >
          {money.symbol}
        </div>
      ))}
    </div>
  );
}